import React, { useMemo } from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '../../../SvgIcon';
import { getReleaseFormatValue } from '@/pages/home/utils/search';
import GameImage from '@/pages/home/components/GameImage';
import { gotoIntelligenceGame } from '@/pages/home/utils/utils';
import {
  getEntityTypeIcon,
  getCombineEntityType,
} from '@/pages/home/pages/home/Explore/_config/common';
import { useIntl, getLocale } from 'umi';
import { StatusBubbleContent } from '@intelligence/components/DataSourceComponents';

export default function HeaderRight(props: any) {
  const { currentItem, isFollowing, setGameFollowing, isFollowingInited } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const locale = getLocale();

  const clickFollowingHandle = () => {
    if (isFollowingInited) {
      setGameFollowing(currentItem);
    }
  };

  // 跳转到情报游戏详情页
  const gotoIntelligenceDetail = (e: any) => {
    e.stopPropagation();
    const { publisher_id = '' } = currentItem;
    gotoIntelligenceGame(publisher_id, 'company', 'Summary');
  };

  const releaseFormatValue = useMemo(() => {
    const isEn = locale === 'en-US';
    return getReleaseFormatValue(currentItem, isEn);
  }, [currentItem, locale]);

  return (
    <div className="right-header">
      <div className="right-header-left">
        <GameImage className={'right-header-img'} src={currentItem?.cover} />
        <div className="right-header-message">
          <div className="right-header-title">
            <span className="right-header-title__text">{currentItem?.entity_name}</span>
            {currentItem?.inactive === true && currentItem?.entity_type === 'mobile' ? (
              <Bubble dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
                <span className="dbi-inactive-tag">{formatMessage({ id: 'dbi_inactive' })}</span>
              </Bubble>
            ) : null}
          </div>
          <div className="right-header-flex">
            <SvgIcon
              type={getEntityTypeIcon(getCombineEntityType(currentItem.entity_type, currentItem))}
              className="card-item-icon"
            />
            <div className="right-header-over">
              <span className="right-header-text">
                {`${formatMessage({ id: 'dbh_metric_release' })} ${
                  releaseFormatValue ? releaseFormatValue : formatMessage({ id: 'dbh_upcoming' })
                }`}
              </span>
              <span className="right-header-text">
                {formatMessage({ id: 'dbh_publisher' })}:{' '}
                <span
                  className="right-header-num"
                  onClick={(e) => {
                    gotoIntelligenceDetail(e);
                  }}
                >
                  {currentItem?.publisher}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      {currentItem.entity_type !== 'combine' && (
        <Bubble
          className="bubble-all-bg"
          arrowPointAtCenter
          dark
          placement="top"
          content={
            isFollowing
              ? formatMessage({ id: 'dbh_unfollow' })
              : formatMessage({ id: 'dbh_follow' })
          }
        >
          <i className="right-header-right" onClick={clickFollowingHandle}>
            <SvgIcon
              className={isFollowing ? 'action-icon' : ''}
              type={isFollowing ? 'star-action' : 'star-m'}
            />
          </i>
        </Bubble>
      )}
    </div>
  );
}
